import React from 'react';
import './InputDropdown.scss';
import { ReactComponent as ChevronDown } from '../../../images/chevron-down.svg';

interface InputDropdownProps {
  value: string;
  onClick: () => void;
  isOpen?: boolean;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  locationsStyle?: string;
}

const InputDropdown: React.FC<InputDropdownProps> = ({
  value,
  onClick,
  isOpen = false,
  placeholder = 'Select...',
  disabled = false,
  className = '',
  locationsStyle = '',
}) => {
  return (
    <button
      type="button"
      className={`input-dropdown ${isOpen ? 'input-dropdown--open' : ''} ${disabled ? 'input-dropdown--disabled' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="input-dropdown__container">
        <div className="input-dropdown__input">
          <div className={`input-dropdown__input-wrapper ${locationsStyle}`}>
            <div className="input-dropdown__content">
              <p className="input-dropdown__text">
                {value || placeholder}
              </p>
            </div>
            <div className="input-dropdown__chevron">
              <ChevronDown />
            </div>
          </div>
        </div>
      </div>
    </button>
  );
};

export default InputDropdown;

